import { declarationsStatementsSave } from "./_declarations_statements_save";

export default {
  declarationsStatementsSave
}
